module.exports = function(gantt){
	var modules = [
		require("./autoscroll"),
		require("./batch_update"),
		require("./wbs"),
		require("./jquery_hooks"),
		require("./dhtmlx_hooks")
	];

	for(var i = 0; i < modules.length; i++){
		if(modules[i])
			modules[i](gantt);
	}
};


//////////////////
// WEBPACK FOOTER
// ./sources/core/plugins/index.js
// module id = 61
// module chunks = 0